export enum SortOrder {
  Backwards = 'backwards',
  Forwards = 'forwards',
}

export const SortOrderLabels: Record<SortOrder, string> = {
  [SortOrder.Backwards]: 'Backwards',
  [SortOrder.Forwards]: 'Forwards',
};

export const SortOrderOptions = Object.entries(SortOrderLabels).map(
  ([value, label]) => ({
    value: value as SortOrder,
    label,
  })
);
